export function supportsNativeClamp() {
    /* istanbul ignore next */
    if (
        typeof document !== 'undefined' &&
        typeof document.documentElement !== 'undefined'
    ) {
        return (
            typeof document.documentElement.style.webkitLineClamp !==
            'undefined'
        );
    }
    /* istanbul ignore next */
    return false;
}
